import ExamList from '@/views/exam/ExamList.vue'
import ExamEdit from '@/views/exam/ExamEdit.vue'
import ExamRoomsList from '@/views/exam/ExamRoomsList.vue'
import ExamRoomsEdit from '@/views/exam/ExamRoomsEdit.vue'
import AdmissionTicketsList from '@/views/exam/AdmissionTicketsList.vue'

export default [

  {
    path: 'exam/edit',
    name: 'ExamCreate',
    component: ExamEdit,
    hidden: true
  },
  {
    path: 'exam/edit/:id',
    name: 'ExamEdit',
    component: ExamEdit,
    hidden: true
  },
  {
    path: 'exam/rooms',
    name: 'ExamRoomsList',
    component: ExamRoomsList,
    meta: { title: '考场管理' },
  },
  {
    path: 'exam',
    name: 'ExamList',
    component: ExamList,
    meta: { title: '考试管理' },
  },
  {
    path: 'exam/rooms/edit',
    name: 'ExamRoomsCreate',
    component: ExamRoomsEdit,
    hidden: true
  },
  {
    path: 'exam/rooms/edit/:id',
    name: 'ExamRoomsEdit',
    component: ExamRoomsEdit,
    hidden: true
  },
  {
    path: 'exam/tickets',
    name: 'AdmissionTicketsList',
    component: AdmissionTicketsList,
    meta: { title: '准考证管理' },
  }
] 


// WEBPACK FOOTER //
// ./src/router/exam.js